import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState, useCallback, useRef } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import WarehouseService from "../../services/WarehouseService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import DataTableManagers from "../../ui/DataTableManagers";
import EditRealWarehouse from "../../ui/EditRealWarehouse";
import withLoader from "../../components/layouts/WithLoader";
import QrCodeModal from "../../ui/QrCodeModal";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Alert, Snackbar } from "@mui/material";
import UtilsUrl from "../../utils/UtilsUrl";
import UpdateStockModal from "../../ui/UpdateStockModal";
import { productImageSrc, onProductImageError } from "../../utils/productImage";

const ProductsByWarehouse = ({ startLoading, stopLoading }) => {
  const [warehouseManagers, setWarehouseManagers] = useState([]);
  const [availableProducts, setAvailableProducts] = useState([]);
  const [warehouse, setWarehouse] = useState([]);
  const [oldWarehouseData, setOldWarehouseData] = useState();
  const [onEditWarehouse, setOnEditWarehouse] = useState(false);
  const [refrech, setRefrech] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [quantityFilter, setQuantityFilter] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [row, setRow] = useState(null);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [updateType, setUpdateType] = useState(""); // "qteMin" or "qteMax"
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();

  // Pagination and search states
  const [currentPage, setCurrentPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [totalSize, setTotalSize] = useState(0);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("ASC");
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [downloading, setDownloading] = useState(false);


  // Refs for debounce
  const searchTimeoutRef = useRef(null);
  const quantityTimeoutRef = useRef(null);

  // Fetch warehouse details and managers
  useEffect(() => {
    const fetchWarehouseData = async () => {
      const warehouseId = sessionStorage.getItem("idWarehouse");

      try {
        const response = await WarehouseService.getAllWarehouseById(
          getCurrentUserId(),
          warehouseId
        );

        if (response.data["success"]) {
          setWarehouse(response.data["success"]);
          setWarehouseManagers(response.data["success"].warehouseManagers || []);
        }
      } catch (e) {
        console.log("error", e);
      } finally {
      }
    };

    fetchWarehouseData();
  }, []);

  // Memoized fetchProducts function for regular pagination
  const fetchProducts = useCallback(async (
    page = currentPage,
    size = sizePerPage,
    sortDir = sortOrder,
    sortBy = sortField,
    quantity = quantityFilter
  ) => {
    setIsLoading(true);
    const warehouseId = sessionStorage.getItem("idWarehouse");

    try {
      // Build query parameters for regular products endpoint
      const params = {
        page: page - 1, // Your API uses 0-based page indexing
        size: size,
        sortDirection: sortDir,
      };

      // Add sort field if provided
      if (sortBy) {
        params.sortBy = sortBy;
      }

      // Add quantity filter if provided
      if (quantity !== "" && quantity !== null && quantity !== undefined) {
        params.quantity = parseInt(quantity, 10);
      }

      // Call regular products web service WITHOUT search
      const response = await WarehouseService.getAllProductsWarehouseById(warehouseId, params);

      if (response.data) {
        setAvailableProducts(response.data.products || []);
        setTotalSize(response.data.totalItems || 0);
      }
    } catch (e) {
      console.log("error", e);
      setAvailableProducts([]);
      setTotalSize(0);
    } finally {
      setIsLoading(false);
    }
  }, [currentPage, sizePerPage, sortField, sortOrder, quantityFilter]);

  // Memoized searchProducts function for dedicated search endpoint
  const searchProducts = useCallback(async (
    search = searchQuery,
    page = currentPage,
    size = sizePerPage,

  ) => {
    setIsSearching(true);
    const warehouseId = sessionStorage.getItem("idWarehouse");

    try {
      // Build query parameters for search endpoint
      const params = {
        page: page - 1, // Your API uses 0-based page indexing
        size: size,
        q: search // This is the search parameter
      };





      // Call the dedicated SEARCH web service
      // Assuming you have a different endpoint for search, e.g., searchWarehouseProducts
      // If not, you'll need to add this method to WarehouseService
      const response = await WarehouseService.getSearchProductsWarehouseById(warehouseId, params);

      if (response.data) {
        setAvailableProducts(response.data.products || []);
        setTotalSize(response.data.totalItems || 0);
      }
    } catch (e) {
      console.log("error", e);
      setAvailableProducts([]);
      setTotalSize(0);
    } finally {
      setIsSearching(false);
    }
  }, [currentPage, sizePerPage, sortField, sortOrder, searchQuery, quantityFilter]);

  // Initial fetch
  useEffect(() => {
    if (searchQuery === "" || searchQuery === "undefined" || searchQuery.trim() === "") {
      // If search is empty, fetch regular products
      fetchProducts(1, sizePerPage, sortOrder, sortField, quantityFilter);
    } else {
      // If search has value, call search endpoint
      searchProducts(searchQuery, 1, sizePerPage, sortOrder, sortField, quantityFilter);
    }
  }, [fetchProducts]);

  // Handle search with debounce
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    setCurrentPage(1); // Reset to first page when searching

    // Clear previous timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    // Set new timeout for debounce
    searchTimeoutRef.current = setTimeout(() => {
      if (value === "" || value === "undefined" || value.trim() === "") {
        // If search is empty, fetch regular products
        fetchProducts(1, sizePerPage, sortOrder, sortField, quantityFilter);
      } else {
        // If search has value, call search endpoint
        searchProducts(value, 1, sizePerPage, sortOrder, sortField, quantityFilter);
      }
    }, 1000); // lance la recherche 1 s après la dernière frappe
  };

  // Handle quantity filter with debounce
  const handleQuantityFilterChange = (e) => {
    const value = e.target.value;
    setQuantityFilter(value);
    setCurrentPage(1); // Reset to first page when filtering

    // Clear previous timeout
    if (quantityTimeoutRef.current) {
      clearTimeout(quantityTimeoutRef.current);
    }

    // Set new timeout for debounce
    quantityTimeoutRef.current = setTimeout(() => {
      if (searchQuery.trim() === "") {
        // If no search query, fetch regular products with quantity filter
        fetchProducts(1, sizePerPage, sortOrder, sortField, value);
      } else {
        // If there's a search query, use search endpoint with quantity filter
        searchProducts(searchQuery, 1, sizePerPage, sortOrder, sortField, value);
      }
    }, 1000); // 500ms debounce
  };

  // Clear timeouts on unmount
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
      if (quantityTimeoutRef.current) {
        clearTimeout(quantityTimeoutRef.current);
      }
    };
  }, []);

  const onEditWarehouseHandler = (
    idWarehouse,
    oldWarehouseName,
    oldWarehouseDesc,
    oldWarehouseReference,
    oldWarehouseManagerId
  ) => {
    let oldWarehouseData = {
      idWarehouse: idWarehouse,
      name: oldWarehouseName,
      description: oldWarehouseDesc,
      warehouseReference: oldWarehouseReference,
      warehouseManagerId: oldWarehouseManagerId,
    };
    setOldWarehouseData(oldWarehouseData);
    setOnEditWarehouse(true);
  };

  // Dynamic page button renderer
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };

    if (page === "...") {
      return (
        <li className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    const activeStyle = active
      ? { backgroundColor: "black", color: "white" }
      : { backgroundColor: "white", color: "black" };

    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
          disabled={disable}
          title={title}
        >
          {page}
        </button>
      </li>
    );
  };

  // Dynamic pagination options
  const options = {
    page: currentPage,
    sizePerPage: sizePerPage,
    totalSize: totalSize,
    pageButtonRenderer,
    showTotal: true,
    paginationSize: 5,
    withFirstAndLast: true,
    alwaysShowAllBtns: false,
    hideSizePerPage: false,
    sizePerPageList: [
      { text: "10", value: 10 },
      { text: "25", value: 25 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
    ],
    onPageChange: (page) => {
      setCurrentPage(page);
      if (searchQuery.trim() === "") {
        fetchProducts(page, sizePerPage, sortOrder, sortField, quantityFilter);
      } else {
        searchProducts(searchQuery, page, sizePerPage, sortOrder, sortField, quantityFilter);
      }
    },
    onSizePerPageChange: (size, page) => {
      setSizePerPage(size);
      setCurrentPage(1);
      if (searchQuery.trim() === "") {
        fetchProducts(1, size, sortOrder, sortField, quantityFilter);
      } else {
        searchProducts(searchQuery, 1, size, sortOrder, sortField, quantityFilter);
      }
    },
  };

  // Handle table sort
  const handleTableChange = (type, { sortField, sortOrder, page, sizePerPage }) => {
    if (type === 'sort') {
      setSortField(sortField);
      setSortOrder(sortOrder);
      if (searchQuery.trim() === "") {
        fetchProducts(currentPage, sizePerPage, sortOrder, sortField, quantityFilter);
      } else {
        searchProducts(searchQuery, currentPage, sizePerPage, sortOrder, sortField, quantityFilter);
      }
    } else if (type === 'pagination') {
      setCurrentPage(page);
      setSizePerPage(sizePerPage);
      if (searchQuery.trim() === "") {
        fetchProducts(page, sizePerPage, sortOrder, sortField, quantityFilter);
      } else {
        searchProducts(searchQuery, page, sizePerPage, sortOrder, sortField, quantityFilter);
      }
    }
  };

  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i className="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };

  const synchroStock = () => {
    startLoading();
    WarehouseService.updateStockPack(sessionStorage.getItem("idWarehouse"))
      .then((response) => {
        setOpenSuccessAlert(true);
        setSuccessAlertText("Enregistrement avec succès");
        // Refresh data after sync
        if (searchQuery.trim() === "") {
          fetchProducts();
        } else {
          searchProducts(searchQuery, currentPage, sizePerPage, sortOrder, sortField, quantityFilter);
        }
      })
      .catch((e) => {
        console.log("error", e);
      })
      .finally(() => {
        stopLoading();
      });
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const handleEdit = (row, type) => {
    setSelectedProduct(row);
    setUpdateType(type);
    setShowUpdateModal(true);
  };

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  function buttonImprimerFormatter(cell, row) {
    return (
      <span>
        <button
          title="Imprimer le QR code"
          className="btn btn-sm btn-outline-dark"
          onClick={() => {
            openModal();
            setRow(row);
          }}
        >
          <i className="fas fa-qrcode"></i>
        </button>
      </span>
    );
  }

  function buttonDeleteFormatter(cell, row) {
    return (
      <span>
        <button
          title="Voir les transactions"
          className="btn btn-sm btn-outline-dark"
          onClick={(e) => {
            localStorage.setItem("idProduct", row.id);
            localStorage.setItem(
              "idWarehouse",
              sessionStorage.getItem("idWarehouse")
            );
            window.open("/TransactionProductsDepot", "_blank");
          }}
        >
          <i className="fas fa-eye"></i>
        </button>
      </span>
    );
  }

  const columns = [
    {
      dataField: "id",
      text: "Image",
      formatter: (cell, row) => (
        <span>
          <img
            alt={row.product?.name || ""}
            src={productImageSrc(row.product?.imagePath)}
          onError={onProductImageError}
            className="rounded"
            style={{
              width: "48px",
              height: "48px",
              objectFit: "cover",
              border: "1px solid #dee2e6",
              backgroundColor: "#f8f9fa",
            }}
          // onError={(e) => {
          //   e.target.onerror = null;
          //   e.target.src = "https://via.placeholder.com/50";
          // }}
          />
        </span>
      ),
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "product.name",
      text: "Libellé",
      headerAlign: "center",
      formatter: (cell) => <strong>{cell}</strong>,
      style: { verticalAlign: "middle" },
      sort: true,
    },
    {
      dataField: "product.productCode",
      text: "Code",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
      sort: true,
    },
    {
      dataField: "product.barcode",
      text: "Code à barre",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
      sort: true,
    },
    {
      dataField: "quantity",
      text: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Qte</span>
          <input
            type="number"
            placeholder="Filter"
            value={quantityFilter}
            onChange={handleQuantityFilterChange}
            style={{
              width: "60px",
              fontSize: "12px",
              padding: "2px 4px",
              border: "1px solid #ced4da",
              borderRadius: "4px",
            }}
          />
        </div>
      ),
      formatter: (cell, row) => {
        const low =
          row.qteMin !== null &&
          row.qteMin !== undefined &&
          cell !== null &&
          cell !== undefined &&
          cell < row.qteMin;
        return (
          <span className={`badge ${low ? "badge-danger" : "badge-light border"}`}>
            {cell !== null && cell !== undefined ? cell : 0}
          </span>
        );
      },
      align: "center",
      headerAlign: "center",
      sort: true,
    },
    {
      dataField: "qteMax",
      text: "Qte Max",
      align: "center",
      headerAlign: "center",
      formatter: (cell, row) => (
        <>
          {cell !== null && cell !== undefined ? cell : 0}
          <button
            onClick={() => handleEdit(row, "qteMax")}
            title="Modifier"
            className="btn btn-sm btn-outline-dark float-right"
          >
            <i className="fas fa-pencil-alt"></i>
          </button>
        </>
      ),
      sort: true,
    },
    {
      dataField: "qteMin",
      text: "Qte Min",
      align: "center",
      headerAlign: "center",
      formatter: (cell, row) => (
        <>
          {cell !== null && cell !== undefined ? cell : 0}
          <button
            onClick={() => handleEdit(row, "qteMin")}
            title="Modifier"
            className="btn btn-sm btn-outline-dark float-right"
          >
            <i className="fas fa-pencil-alt"></i>
          </button>
        </>
      ),
      sort: true,
    },
    {
      dataField: "id",
      text: "Transaction",
      formatter: buttonDeleteFormatter,
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "Imprimer",
      text: "Imprimer",
      formatter: buttonImprimerFormatter,
      align: "center",
      headerAlign: "center",
    },
  ];

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  // Barre de recherche : rendue par une fonction (et non un composant défini
  // dans le composant) pour que le champ ne soit pas recréé à chaque frappe
  // et garde le focus pendant la saisie.
  const renderSearchBar = () => {
    return (
      <div className="input-group" style={{ width: "250px" }}>
        <input
          type="text"
          className="form-control"
          placeholder="Chercher par nom, code, barre..."
          value={searchQuery}
          onChange={handleSearchChange}
          style={{ borderRight: "none" }}
        />
        <div className="input-group-append">
          <span className="input-group-text" style={{ backgroundColor: "white", borderLeft: "none" }}>
            {isSearching ? (
              <i className="fas fa-spinner fa-spin text-dark"></i>
            ) : (
              <i className="fas fa-search text-dark"></i>
            )}
          </span>
        </div>
      </div>
    );
  };

  const handleDownload = async () => {
    try {
      setDownloading(true);

      const response =
        await WarehouseService.exportWarehouseExcel(getCurrentUserId(),sessionStorage.getItem("idWarehouse"));

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      setDownloading(false);

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "discount_products.xlsx");

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed", error);
    }
  };



  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-warehouse mr-2"></i>
                {warehouse.ref ? `${warehouse.ref} - ${warehouse.name}` : "Dépôt"}
              </h4>
              <small className="text-muted">
                {warehouse.address || "Produits et stocks du dépôt"}
              </small>
            </div>
          </div>
          {sessionStorage.getItem("typeDocument") === "Warehouse" && (
            <div className="row">
              {[
                {
                  label: "Dépôt",
                  value: warehouse.name || "-",
                  sub: warehouse.ref,
                  icon: "fas fa-map-marker-alt",
                },
                {
                  label: "Managers",
                  value: warehouseManagers.length,
                  sub: "responsables du dépôt",
                  icon: "fas fa-user-tie",
                },
                {
                  label: "Produits",
                  value: totalSize,
                  sub: "produits au total",
                  icon: "fas fa-boxes",
                },
              ].map((item) => (
                <div className="col-md-4 col-sm-6 col-12" key={item.label}>
                  <div
                    className="d-flex align-items-center p-3 mb-3 bg-white"
                    style={{
                      borderRadius: 8,
                      boxShadow: "0 1px 6px rgba(0,0,0,.08)",
                      borderLeft: "4px solid #343a40",
                    }}
                  >
                    <span
                      className="d-flex align-items-center justify-content-center bg-dark text-white mr-3"
                      style={{ width: 48, height: 48, borderRadius: 8 }}
                    >
                      <i className={item.icon}></i>
                    </span>
                    <div>
                      <small
                        className="text-muted text-uppercase d-block"
                        style={{ fontWeight: 600, letterSpacing: "0.03em" }}
                      >
                        {item.label}
                      </small>
                      <span style={{ fontSize: "1.25rem", fontWeight: 700 }}>
                        {item.value}
                      </span>
                      <small className="text-muted d-block">{item.sub}</small>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className="row ">
            <div className="col-sm-12">
              {warehouseManagers && (
                <div
                  className="card card-outline card-dark"
                  style={{ borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" }}
                >
                  <div className="card-header">
                    <h3 className="card-title">
                      <i className="fas fa-user-tie mr-2"></i>Managers
                    </h3>

                    <button
                      title="Modifier le dépôt"
                      className="btn btn-sm btn-outline-dark float-right"
                      data-toggle="modal"
                      data-target="#edit-warehouse"
                      onClick={() =>
                        onEditWarehouseHandler(
                          warehouse.id,
                          warehouse.name,
                          warehouse.description,
                          warehouse.ref,
                          warehouse.warehouseManegerId
                        )
                      }
                    >
                      <i className="fas fa-pencil-alt"></i>
                    </button>
                  </div>
                  <div className="card-body">
                    <DataTableManagers
                      listManagers={warehouseManagers}
                      idWarehouse={warehouse.id}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="row ">
            <div className="col-sm-12">
              <div
                className="card card-outline card-dark"
                style={{ borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" }}
              >
                <div className="card-header">
                  <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <h3 className="card-title mb-0">
                      <i className="fas fa-boxes mr-2"></i>Produits
                      <span className="badge badge-dark ml-2">{totalSize}</span>
                    </h3>
                    <div>
                      <button
                        className="btn btn-outline-dark mr-2"
                        disabled={downloading}
                        onClick={() => handleDownload()}
                      >
                        <i className="fas fa-file-excel mr-1"></i>
                        {downloading
                          ? "Génération..."
                          : "Télécharger Excel des produits"}
                      </button>
                      <button
                        className="btn btn-dark"
                        onClick={(e) => {
                          synchroStock();
                        }}
                      >
                        <i className="fas fa-sync-alt mr-1"></i>
                        Synchroniser les packs
                      </button>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <ToolkitProvider
                    keyField="id"
                    data={availableProducts}
                    columns={columns}
                    exportCSV
                    search
                  >
                    {(props) => (
                      <div>
                        <div className="row ml-0 mb-3">
                          <div className="col-md-6">
                            {renderSearchBar()}
                          </div>
                          <div className="col-md-6 text-right">
                            <MyExportCSV {...props.csvProps}></MyExportCSV>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <BootstrapTable
                              {...props.baseProps}
                              remote={{
                                pagination: true,
                                sort: true,
                                filter: false,
                              }}
                              onTableChange={handleTableChange}
                              pagination={paginationFactory(options)}
                              headerClasses="thead-light"
                              wrapperClasses="table-responsive"
                              striped
                              hover
                              condensed
                              noDataIndication={() => (
                                <div className="text-center py-4">
                                  {isLoading || isSearching ? (
                                    <div>
                                      <i className="fas fa-spinner fa-spin fa-2x text-dark mb-2"></i>
                                      <p>Chargement en cours...</p>
                                    </div>
                                  ) : (
                                    <div>
                                      <i className="fas fa-box-open fa-2x text-muted mb-2"></i>
                                      <p>Aucun produit trouvé</p>
                                      {searchQuery && (
                                        <small className="text-muted">
                                          Essayez avec d'autres termes de recherche
                                        </small>
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </ToolkitProvider>
                </div>
                <QrCodeModal isOpen={showModal} onClose={closeModal} row={row} />
                {openInfoAlert && (
                  <Snackbar
                    open={openInfoAlert}
                    autoHideDuration={2000}
                    onClose={handleInfoClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                  >
                    <Alert
                      variant="filled"
                      onClose={handleInfoClose}
                      severity="info"
                    >
                      {infoAlertText}
                    </Alert>
                  </Snackbar>
                )}
                <UpdateStockModal
                  show={showUpdateModal}
                  onClose={() => {
                    setShowUpdateModal(false);
                    // Refresh data after update
                    if (searchQuery.trim() === "") {
                      fetchProducts();
                    } else {
                      searchProducts(searchQuery, currentPage, sizePerPage, sortOrder, sortField, quantityFilter);
                    }
                  }}
                  product={selectedProduct}
                  type={updateType}
                  idWarehouse={sessionStorage.getItem("idWarehouse")}
                  idUser={getCurrentUserId()}
                />

                <Snackbar
                  open={openSuccessAlert}
                  autoHideDuration={2000}
                  onClose={handleSuccessClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                >
                  <Alert
                    variant="filled"
                    onClose={handleSuccessClose}
                    severity="success"
                  >
                    {successAlertText}
                  </Alert>
                </Snackbar>
              </div>
            </div>
          </div>
        </div>
      </section>
      {onEditWarehouse && (
        <EditRealWarehouse
          setOnEditWarehouse={setOnEditWarehouse}
          oldWarehouseData={oldWarehouseData}
        />
      )}
    </div>
  );
};

export default withLoader(ProductsByWarehouse);